<div class="profile">
      <div class="avatar-wrapper" [ngClass]="{'collapsed': isCollapsed()}">
        @if (!isCollapsed()) {
        <div class="profile-btn">
          <!-- <p-speeddial [model]="profiles" direction="down" [(visible)]="speedDialVisible">
            <ng-template #button>
              <button 
                type="button" 
                class="icon-btn" 
                aria-label="Cambiar perfil" 
                (click)="onToggleSpeedDial($event)"
              >
                <img src="/shell/profile/rotate-left.svg" alt="Cambiar perfil" />
              </button>
            </ng-template>
            <ng-template #item let-item let-index="index">
              <button [disabled]="perfilActivo() === item.label" (click)="goToRibera(index)" (keydown.enter)="goToRibera(index)" tabindex="0" class="user-switch" [class.no-active]="perfilActivo() === item.label">
                <div class="title">
                  <img [src]="item.icon" [alt]="item.label" />
                  <span>{{ item.label }}</span>
                </div>
                <div class="pin" [style.--icon-url]="'url(shell/profile/pin.svg)'"></div>
              </button>
            </ng-template>
          </p-speeddial> -->
        </div>
        }
        <p-avatar style="width: 75%; height: 75%;" [image]="userDataSateService.userProfileImage() || '/member/dashboard/user-image-default.png'" shape="circle" size="xlarge" ></p-avatar>
        <svg class="progress-ring" viewBox="0 0 100 100">
          <circle class="bg" cx="50" cy="50" r="45" />
          <circle class="fg" cx="50" cy="50" r="45" [attr.stroke-dasharray]="circumference" [attr.stroke-dashoffset]="dashOffset"/>
        </svg>
      </div>

      @if(!isCollapsed()){
      <div class="info">
        @if (isUserTyePromoter()) {
        <span (click)="onToggleSpeedDial($event)" (keydown.enter)="onToggleSpeedDial($event)" tabindex="1">
          {{perfilActivo()}}
          <img src="/assets/change.svg" alt="">
        </span>
        }
        <h2>{{loggedUserName}}</h2>
        
        <p>{{messagePerfil()}}</p>
      </div>
      }
      <div class="actions" [ngClass]="{'columns': isCollapsed()}" >
        @if (shellDataService.isPromotorPerfil()) {
        <button 
          #rewardBtn
          type="button" 
          class="icon-btn alert" 
          aria-label="Recompensas"
          (click)="openReward(rewardBtn)"
        >
          <i class="pi pi-info-circle"></i>
          <img src="/shell/profile/cup.svg" alt="Recompensas" />
        </button>

        <button type="button" class="icon-btn" aria-label="Notificaciones">
          <img src="/shell/profile/notification.svg" alt="Notificaciones" />
        </button>
        
        <div
          type="button" 
          class="icon-btn-animated" 
          [class.active]="toggle"
          aria-label="Código QR"
          (click)="op.toggle($event, targetEl)"
          tabindex="0"
          (keydown.enter)="op.toggle($event, targetEl)" label="Show"
        >
          <div style="position: absolute; width: 10px; height: 10px; bottom: 10px; left: 0;" #targetEl ></div>
          <img src="/shell/profile/qr.svg" alt="Código QR" />
        </div>
        
        <p-popover styleClass="black" #op [ptOptions]="">
            <ng-template #content>
                <lib-tooltip-qr></lib-tooltip-qr>
            </ng-template>
        </p-popover>
        } @else {
            <button class="sidebar-action"><img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/btn.svg" alt="Notificación" /></button>
            <button class="sidebar-action"><img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/btn+(1).svg" alt="Mail" /></button>
            <button class="sidebar-action"><img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/btn+(2).svg" alt="Teléfono" /></button>
          
        }
      </div>
      
    </div>
